/**
 * Buy box behaviour.
 *
 * Keeps the button total in step with the chosen bundle tier and add-ons,
 * then adds the main product plus any ticked add-ons in a single
 * /cart/add.js request. A sticky bar mirrors the button on small screens.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-nova-buy-section]').forEach(setup);
  });

  function setup(section) {
    var root = section.querySelector('[data-nova-buy]');
    if (!root) return;

    var button = root.querySelector('[data-nova-add]');
    var label = root.querySelector('[data-nova-label]');
    var totalEl = root.querySelector('[data-nova-total]');
    var error = root.querySelector('[data-nova-error]');
    var select = section.querySelector('[data-nova-variant-select]');
    var sticky = section.querySelector('[data-nova-sticky]');
    var stickyTotal = section.querySelector('[data-nova-sticky-total]');
    var format = section.dataset.moneyFormat;
    var original = label ? label.textContent.trim() : '';

    function money(cents) { return window.novaMoney ? window.novaMoney(cents, format) : (cents / 100).toFixed(2); }

    function unitPrice() {
      if (select) {
        var opt = select.options[select.selectedIndex];
        return Number(opt && opt.dataset.price) || Number(root.dataset.price) || 0;
      }
      return Number(root.dataset.price) || 0;
    }

    function tierBox() { return section.querySelector('.nova-tier__box:checked'); }

    function quantity() {
      var tier = tierBox();
      return tier ? Number(tier.value) || 1 : 1;
    }

    // Tier totals were rendered for the first variant; rescale when a
    // different variant (with a different price) is chosen.
    function mainTotal() {
      var tier = tierBox();
      if (!tier) return unitPrice();
      var base = Number(root.dataset.price) || 0;
      var rendered = Number(tier.dataset.total) || 0;
      if (!base) return rendered;
      return Math.round(rendered * (unitPrice() / base));
    }

    function addonTotal() {
      var sum = 0;
      section.querySelectorAll('.nova-addon__box:checked').forEach(function (box) {
        sum += Number(box.dataset.price) || 0;
      });
      return sum;
    }

    function paint() {
      var total = mainTotal() + addonTotal();
      if (totalEl) totalEl.textContent = money(total);
      if (stickyTotal) stickyTotal.textContent = money(total);
    }

    section.addEventListener('change', function (e) {
      if (e.target.matches('.nova-tier__box, .nova-addon__box, [data-nova-variant-select]')) paint();
    });
    paint();

    button.addEventListener('click', add);

    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-nova-sticky-add]');
      if (stickyBtn) stickyBtn.addEventListener('click', add);

      // Show the bar only once the real button has scrolled out of view.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', off);
          sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = off ? 0 : -1;
        }).observe(button);
      }
    }

    function add() {
      var variant = select ? Number(select.value) : Number(root.dataset.variant);
      var items = [{ id: variant, quantity: quantity() }];

      section.querySelectorAll('.nova-addon__box:checked').forEach(function (box) {
        var id = Number(box.value);
        if (id) items.push({ id: id, quantity: 1 });
      });

      setBusy(true);
      hideError();

      fetch(route('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'That could not be added.');
            return body;
          });
        })
        .then(function () {
          var next = root.dataset.redirect;
          if (next === 'checkout') {
            window.location.href = route('checkout');
          } else if (next === 'cart') {
            window.location.href = route('cart');
          } else {
            setBusy(false);
            document.dispatchEvent(new CustomEvent('nova:cart-updated'));
          }
        })
        .catch(function (err) {
          setBusy(false);
          showError(err.message);
        });
    }

    function setBusy(state) {
      button.disabled = state;
      button.setAttribute('aria-busy', state ? 'true' : 'false');
      if (label) label.textContent = state ? 'Adding…' : original;
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function hideError() {
      if (!error) return;
      error.hidden = true;
      error.textContent = '';
    }
  }

  function route(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base + path;
  }
})();
